<template>
    <form @submit.prevent="onSubmit" class="form-horizontal form-material">
        <div class="card text-white bg-danger" v-if="Object.keys(errors).length">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Validation Errors</h4></div>
            <div class="card-body">
                <p v-if="typeof errors === 'string'" class="card-text">{{errors}}</p>
                <p v-else class="card-text" v-for="(error, key) in errors.offer" :key="key">
                    {{key}}: {{error[0]}}
                </p>
            </div>
        </div>
        <br/>

        <div class="mb-4" v-if="this.$store.getters.isAdmin">
            <label>Owner:</label>
            <treeselect v-model="offer.user" placeholder="Select Owner" :multiple="false"
                        :options="userSelect" :load-options="loadUsers" value-format="object" :disabled="isArchive"/>
        </div>
        <div class="mb-4">
            <label>Category:</label>
            <treeselect v-model="offer.category" placeholder="Select Category" :multiple="false"
                        :options="categorySelect" :load-options="loadCategories" value-format="object" :disabled="isArchive"/>
            <div class="text-danger" v-if="$v.offer.category.$error">Category is required.</div>
        </div>
        <div class="form-group" :class="{ 'form-group--error': $v.offer.name.$error }">
            <label for="offer_name" class="mb-1">Name:</label>
            <input v-model="$v.offer.name.$model" type="text" class="form-control" id="offer_name" name="offer_name" :disabled="isArchive">
            <div class="text-danger" v-if="$v.offer.name.$error">Name is required.</div>
        </div>
        <div class="form-group">
            <label for="offer_url" class="mb-1">URL:</label>
            <small class="form-text text-muted mt-0">
                You can use here: [click_id], [trk], [email].
            </small>
            <input v-model="offer.url" type="text" class="form-control" id="offer_url" name="offer_url" :disabled="isArchive">
            <div v-if="$v.offer.url.$error">
                <div class="text-danger" v-if="!$v.offer.url.url">Invalid url.</div>
                <div class="text-danger" v-if="!$v.offer.url.required">Url is required.</div>
            </div>
        </div>
        <div class="form-group">
            <label for="offer_plug_url" class="mb-1">Plug URL:</label>
            <small class="form-text text-muted mt-0">
                Replaces the URL(Optional)
            </small>
            <input v-model="offer.plug" type="text" class="form-control" id="offer_plug_url" name="offer_plug">
            <div v-if="$v.offer.plug.$error">
                <div class="text-danger" v-if="!$v.offer.plug.url">Invalid url.</div>
            </div>
        </div>
        <div class="form-group">
            <label for="offer_callback" class="mb-1">Callback</label>
            <input v-model="offer.callback" type="text" class="form-control"
                   placeholder="unrealized functionality"
                   id="offer_callback" name="offer_callback" disabled>
        </div>
        <br>
        <div class="form-group text-center p-b-20 p-t-20">
            <div class="col-xs-12">
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light">
                    Save
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import Breadcrumb from '../../components/Breadcrumb';
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import CategoryService from '../../services/CategoryService'
    import OfferService from "../../services/OfferService";
    import {required, url} from 'vuelidate/lib/validators';
    import Preloader from '../../components/Preloader';
    import UserService from '../../services/UserService';

    export default {
        name: 'Offer',
        props: ['id'],
        components: {Breadcrumb, Treeselect, Preloader},
        data() {
            return {
                offer: {
                    category: null,
                    name: '',
                    url: '',
                    callback: '',
                    user: null,
                    plug: '',
                    archive: null
                },
                userSelect: null,
                categorySelect: null,
                errors: {},
                isArchive: false,
            }
        },
        mounted() {
            if (this.id) {
                OfferService.getOffer(this.id).then(response => {
                    this.offer = response.data;
                    this.offer.url = decodeURI(this.offer.url);
                    this.offer.callback = decodeURI(this.offer.callback);
                    this.offer.plug = this.offer.plug !== null ? decodeURI(this.offer.plug) : '';
                    this.$emit('hidePreloader', true);
                    this.isArchive = this.offer.archive !== null;
                });
            }
        },
        validations: {
            offer: {
                category: {required},
                name: {required},
                url: {required, url},
                user: {required},
                plug: {url}
            }
        },
        methods: {
            loadUsers({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userSelect = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            },
            loadCategories({callback}) {
                CategoryService.getCategories().then(response => {
                    this.categorySelect = response.data.map(category => {
                        return {id: category.id, label: category.text}
                    });
                    callback();
                });
            },
            onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) return;
                this.$emit('hidePreloader', false);

                let submitMethod = null;

                let offerClone = Object.assign({}, this.offer);
                offerClone.category = '/api/categories/' + offerClone.category.id;
                offerClone.url = encodeURI(offerClone.url);
                offerClone.callback = (offerClone.callback !== undefined) ? encodeURI(offerClone.callback) : offerClone.callback;

                if (this.id) {
                    submitMethod = OfferService.updateOffer(this.id, JSON.stringify(offerClone));
                } else {
                    submitMethod = OfferService.addOffer(JSON.stringify(offerClone));
                }

                submitMethod.then(response => {

                    if (response.data.error !== undefined) {
                        this.errors = response.data.error;
                        this.$emit('hidePreloader', true);
                    } else {
                        this.$router.push({name: 'offersList'});
                    }
                });
            }
        }
    }
</script>